import {
  BankInterface,
  BankActionInterface,
  BankSocketPriority,
} from "../interfaces/Bank.interface";

// eslint-disable-next-line import/prefer-default-export
export const BLANK_BANK: BankInterface = {
  id: "",
  name: "",
  type: "ELEVATOR",
  channel_id: "",
  server_id: "",
  columns: 0,
  stops: 0,
  number_of_lifts: 0,
  logical_port: 0,
  floor_count: 0,
  floor_below_lobby: 0,
  board: 1,
  rear_doors: false,
  active: true,
  control_panel: "",
  lifts: [],
  offsets: [],
  floor_names: [],
  direct_link: "",
  configurations: [],
  data_blocks: [],
  start_floor_no: 1,
  interface: {},
  bank_floors: [],
  actions: [],
  cmd_binary_control: false,
  socket_message_priority: {
    activeLevel: 1,
    messageTypes: [],
  },
  clear_bacnet_config: false,
  bacnet_config_raw: {
    descriptions: [],
    bank: {},
    bank_id: "",
  },
};

export const BLANK_BANK_ACTION: BankActionInterface = {
  id: "",
  bank_id: "",
  message_id: "",
  color: "#38ac68",
  timer: 1,
  label: "",
  valid_states: [],
  toggle_message_id: "",
  toggle_color: "#f94d4f",
  toggle_timer: 1,
  toggle_label: "",
  toggle_valid_states: [],
  button_type: "TOGGLE",
  created_at: "",
};

export const DEFAULT_MONITORING_PRIORITY: BankSocketPriority = {
  activeLevel: 1,
  messageTypes: [],
};
